<template>
  <a-modal
    title="子公式"
    :width="1200"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" layout="horizontal" :model="model" v-bind="{labelCol: { span: 2 },wrapperCol: { span: 22 },}" :rules="rules">

        <a-form-model-item prop="name" label="公式名称" >
          <a-input placeholder="请输入公式名称" v-model="model.name" />
        </a-form-model-item>

        <a-form-model-item  label="数据源" >
          <a-card size='small'>
            <a-button type="primary" @click='write' style="margin-bottom: 10px;margin-right: 10px" v-for="(item,index) in itemList" :key="index" >{{item.name}}</a-button>
            <br/>
            <a-button type="primary" @click='write'>(当前时间)</a-button>
          </a-card>
        </a-form-model-item>
        <a-form-model-item  label="公式" prop="formula" >
          <a-card size='small' >
            <a-button  @click='write' style="margin-bottom: 10px">-</a-button>
            <a-textarea v-model='model.formula' :autoSize='{minRows: 6, maxRows: 12}' style='font-size: 16px'></a-textarea>
          </a-card>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import baseRules from '@/constants/baseRules'
export default {
  name: 'SubformulaModel',
  data () {
    return {
      title:"添加子公式",
      visible: false,
      model: {},
      rules:{
        name:[baseRules.required],
        formula:[baseRules.required],
      },
      confirmLoading: false,
      validatorRules:{
      },
      url: {
      },
      itemList:[],
      index:null,
    }
  },
  created () {
  },
  methods: {
    view (record,itemList,index) {
      this.index = index
      this.itemList = itemList
      this.model = Object.assign({}, record);
      this.visible = true;
    },
    close () {
      this.$emit('close');
      this.visible = false;
      this.$refs.form.clearValidate();
    },
    handleOk () {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.$emit('ok', Object.assign({},this.model),this.index);
          that.close();
        }else{
          return false;
        }
      })
    },
    handleCancel () {
      this.close()
    },

    /**
     * 将变量插入/追加到公式内容中
     * @param e
     */
    write(e) {
      const text = e.target.innerText
      if (text) {
        this.$set(this.model, 'formula', (this.model.formula||'') + text)
      }
    }

  }

}
</script>

<style scoped lang='less'>
</style>
